<template>
	<div class="c-adviser" :class="{ 'c-adviser--negative': negative }">
		<div class="c-adviser__inactive" v-if="!active && !isError">
			<p class="title">Find din lokale Rådgiver</p>
			<div class="c-adviser__inactive__wrapper" v-if="!active">
				<div class="c-adviser__inactive__image" v-if="negative">
					<img :src="fallback" alt="" />
				</div>
				<div class="input__wrapper">
					<input
						aria-label="Postnummer"
						id="postal"
						class="input"
						type="text"
						pattern="\d*"
						maxlength="4"
						name="postal"
						v-model="postal"
						:class="{
							'input--filled': postal,
						}"
						@keyup.enter="submitAdviser(postal)"
					/>
					<label
						for="postal"
						class="input__label"
						:class="{ 'input__label--error': isError }"
					>
						Dit postnr...
					</label>

					<div class="input__submit" @click="submitAdviser(postal)">
						<iArrow v-if="!isLoading" />
						<div class="bouncyBoisMini" v-if="isLoading">
							<div></div>
							<div></div>
							<div></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="c-adviser__active" v-if="active && !isError">
			<p class="title">Kontakt din rådgiver</p>
			<div class="adviser">
				<div class="adviser__image">
					<img :src="adviserData.image" alt="" />
				</div>
				<div class="adviser__info">
					<p class="bold">{{ adviserData.name }}</p>
					<p>{{ adviserData.jobtitle }}</p>
					<a :href="'mailto:' + adviserData.email">{{ adviserData.email }}</a>
					<a class="bold" :href="'tel:+45' + adviserData.phone"
						>Direkte: +45{{ adviserData.phone }}</a
					>
					<div class="change">
						<span>Rådgiver for postnummer</span><span>{{ postal }}.</span>
						<span class="anchor" @click="removeAdviser()"> Skift</span>
					</div>
				</div>
			</div>
		</div>
		<div class="error" :class="{ error__menu: !negative }" v-if="isError">
			<p class="error__text">Rådgiver ikke fundet for det givne postnummer</p>
			<a
				class="o-btn o-btn--main o-btn--back"
				:class="{ 'o-btn--white': negative }"
				@click.prevent="toForm()"
				><iArrow />
				<p>Prøv igen</p></a
			>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import iArrow from '@web/assets/icon/btnArrow.svg';
import axios from 'axios';

export default defineComponent({
	name: 'c-adviser',
	components: {
		iArrow,
	},
	props: {
		negative: Boolean,
		fallback: String,
	},
	data: () => {
		return {
			active: false,
			adviserData: [],
			postal: null,
			isError: false,
			isLoading: false,
		};
	},
	methods: {
		submitAdviser(code) {
			this.isLoading = true;

			axios.get('/api/qd/adviser/' + code).then((res) => {
				if (!res.data.name) {
					this.isError = true;
					this.isLoading = false;
					this.$cookies.remove('adviserPref');
				} else {
					this.adviserData = res.data;

					this.active = true;
					this.isError = false;
					this.isLoading = false;
				}
				this.postal = code;
			});
		},
		toForm() {
			this.isLoading = false;
			this.active = false;
			this.isError = false;
			this.postal = null;
			this.$cookies.remove('adviserPref');
		},
		removeAdviser() {
			this.postal = null;
			this.$cookies.remove('adviserPref');
			this.active = false;
		},
	},
	watch: {
		active: function (val) {
			if (document.getElementById('hours')) {
				let element = document.getElementById('hours').classList;
				val
					? element.add('o-hours--opacity')
					: element.remove('o-hours--opacity');
			}
		},
	},
	mounted() {
		if (this.$cookies.isKey('adviserPref')) {
			this.submitAdviser(this.$cookies.get('adviserPref'));
			this.isError = false;
		} else {
			this.active = false;
			this.isError = false;
		}
	},
});
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.c-adviser {
	.bouncyBoisMini {
		left: -12px;
	}
	.error {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-left: 100px;
		margin-bottom: 10px;

		&__text {
			margin-bottom: 10px;
		}
		&__menu {
			margin-left: 0;
			flex-direction: column;
			align-items: flex-start;
		}
	}
	&__inactive {
		width: 100%;
		&__wrapper {
			display: flex;
			align-items: center;
		}

		&__image {
			margin-right: 10px;
			img {
				position: relative;
				top: 5px;
				object-fit: contain;
				width: 100px;
				height: 60px;
			}
		}
		p {
			font-size: 13px;
			line-height: 16px;
			letter-spacing: -0.13px;
			font-weight: $f-bold;
			color: $c-darkblue;
			text-transform: uppercase;
			margin-bottom: 27px;
		}

		.input {
			&__wrapper {
				height: 55px;
				position: relative;
				width: 100%;
				display: flex;
			}
			height: 100%;
			padding-top: 15px;
			padding-left: 17px;
			background-color: $c-white;
			border: none;
			width: calc(100% - 56px);
			font-size: 16px;

			border-radius: 50px;
			border: 1px solid #dadada;

			&__label {
				position: absolute;
				top: 17.5px;
				left: 17px;
				font-size: 17px;
				font-weight: $f-medium;
				letter-spacing: -0.13px;
				line-height: 18px;
				color: $c-black;
				opacity: 0.4;
				pointer-events: none;
				touch-action: none;
				transition: all 0.3s $t-nice;

				&--error {
					color: red;
				}
			}

			&:focus,
			&--filled {
				~ .input__label {
					top: 6px;
					left: 17px;
					font-size: 9px;
					font-weight: 700;
					letter-spacing: -0.07px;
				}
			}
			&__submit {
				cursor: pointer;
				width: 55px;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #d2763b;
				border-radius: 50%;
				margin-left: 6px;

				padding-right: 19px;
				padding-left: 19px;
				transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);

				svg {
					height: 16px;
					width: 16px;
					min-width: 16px;
					min-height: 16px;
					// margin-right: 10px;
					.fill {
						fill: $c-white;
					}
					.hover {
						transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
					}
				}
				&:hover {
					padding-right: 23px;
					padding-left: 15px;
					svg {
						transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
						.hover {
							transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
							opacity: 0;
						}
					}
				}
			}
		}
	}

	&__active {
		width: 100%;
		.title {
			font-size: 13px;
			line-height: 16px;
			letter-spacing: -0.13px;
			font-weight: $f-bold;
			color: $c-darkblue;
			text-transform: uppercase;
			margin-bottom: 27px;
		}
		.adviser {
			display: flex;
			&__image {
				margin-right: 10px;
				img {
					width: 50px;
					height: 50px;
					min-width: 50px;
					object-fit: cover;
					border-radius: 50%;
					border: 2px solid $c-light;
				}
			}

			&__info {
				.bold {
					font-weight: $f-bold;
				}

				p,
				a,
				span {
					font-size: 16px;
					line-height: 19px;
					letter-spacing: -0.16px;
					display: flex;
					color: $c-darkblue;
					margin-bottom: 2px;
					font-weight: $f-regular;
				}

				a {
					&:hover {
						color: $c-red !important;
					}
				}

				.change {
					margin-top: 10px;
					white-space: normal;
					display: flex;
					flex-wrap: wrap;

					span {
						font-size: 12px;
						margin-left: 2px;
					}

					.anchor {
						cursor: pointer;
						text-decoration: underline;
						transition: $t-hover;
						&:hover {
							transition: $t-hover;
							color: $c-red;
						}
					}
				}
			}
		}
	}

	&--negative {
		width: calc(80% + 100px);
		display: flex;
		justify-content: flex-end;
		.c-adviser {
			&__inactive {
				position: relative;
				// left: -100px;
				width: 100%;
				// width: calc(100% + 100px);
				// width: calc(80% + 100px);
				display: flex;
				flex-direction: column;
				justify-content: flex-end;
				.title {
					text-transform: none;
					font-size: 18px;
					font-weight: $f-bold;
					margin-bottom: 18px;
					color: $c-white;
					margin-left: 90px;
				}
				.input__wrapper {
					// margin-bottom: 15px;
				}
			}
			&__active {
				width: 80%;
				// margin-left: 100px;
				justify-content: flex-end;
				.title {
					color: $c-white;
					text-transform: none;
					font-size: 18px;
					letter-spacing: -0.18px;
				}
				.adviser {
					&__image {
						img {
							border: 2px solid $c-white;
						}
					}

					&__info {
						p,
						a,
						span {
							color: $c-white;
						}
					}
					margin-bottom: 10px;
				}
			}
		}
	}
}

@media all and (max-width: 1024px) {
	.c-adviser {
		.error {
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			margin-left: 0px;

			&__menu {
				margin-left: 0;
				flex-direction: column;
				align-items: flex-start;
			}
		}

		&--negative {
			width: 100%;
			justify-content: flex-start;
			.c-adviser {
				&__inactive {
					.title {
						margin-left: 0;
					}
				}
			}
		}
	}
}

@media all and (max-width: 700px) {
	.c-adviser {
		.error {
			flex-direction: column;
			align-items: flex-start;
			margin-left: 0px;
		}
	}
}

@media all and (max-width: 510px) {
	.c-adviser--negative {
		width: 100%;
		.c-adviser {
			&__active {
				width: 100%;
			}
			&__inactive {
				&__image {
					display: none;
					margin-bottom: 15px;
				}
				&__wrapper {
					max-width: 100%;
					margin-top: 10px;
					margin-bottom: 5px;
					align-items: flex-start;
					flex-direction: column;
				}
			}
		}
	}
}
</style>
